import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {formatMoney} from '@/utils/filters';
import { BTable, ModalPlugin, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false


Vue.component('b-table', BTable)

Vue.filter('money', formatMoney);

Vue.use(IconsPlugin)
Vue.use(ModalPlugin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
